import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_vm.twinType === 'virtualDevice' && _vm.lclModel.key === '_health' ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dtwin-state-virtual-device-aggregate-health', {
    ref: "healthStateEdit",
    attrs: {
      "mode": _vm.mode,
      "lclModel": _vm.lclModel,
      "tenantId": _vm.tenantId,
      "twinModel": _vm.twinModel,
      "otherStates": _vm.otherStates
    },
    on: {
      "bridge-binding-changed": _vm.bridgeBindingChanged,
      "no-permission": e => _vm.$emit('no-permission', e),
      "stateUpdated": function ($event) {
        return _vm.$emit('stateUpdated');
      }
    },
    model: {
      value: _vm.lclModel.properties.binding.options.virtualDevice,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.binding.options, "virtualDevice", $$v);
      },
      expression: "lclModel.properties.binding.options.virtualDevice"
    }
  })], 1) : _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.description')) + "\n      ")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [!_vm.templateContext ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    ref: "virtualDevice",
    attrs: {
      "items": _vm.virtualDevices,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "loading": _vm.loadingDevices,
      "search-input": _vm.virtualDeviceSearch,
      "placeholder": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.devicePlaceholder'),
      "hide-selected": _vm.loadingDevices || !_vm.virtualDeviceSearch || _vm.virtualDeviceSearch.length < 1,
      "hide-no-data": _vm.loadingDevices || !_vm.virtualDeviceSearch || _vm.virtualDeviceSearch.length < 1,
      "no-data-text": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.deviceNoResults'),
      "label": _vm.virtualDeviceSourceName,
      "rules": _vm.requiredRule,
      "item-value": "id",
      "item-text": "title",
      "autocomplete": "off",
      "return-object": "",
      "no-filter": "",
      "hide-details": "",
      "data-cy": "aggregated_state_virtual_device_source"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.virtualDeviceSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.virtualDeviceSearch = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                ")]), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(_vm.get(data.item, 'properties.bridge.deviceData.device_id'))
          }
        })], 1)];
      }
    }], null, false, 919570852),
    model: {
      value: _vm.selectedVirtualDevice,
      callback: function ($$v) {
        _vm.selectedVirtualDevice = $$v;
      },
      expression: "selectedVirtualDevice"
    }
  })], 1) : _vm._e(), !_vm.templateContext && _vm.selectedVirtualDevice && _vm.selectedVirtualDevice.id ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": `/#/virtual-devices/${_vm.selectedVirtualDevice.id}`,
      "target": "_blank"
    }
  }, [_vm._v("\n            » " + _vm._s(_vm.selectedVirtualDevice.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.selectedVirtualDevice.id) + ")\n          ")])]) : _vm._e(), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.templateContext && _vm.virtualDeviceStates || _vm.selectedVirtualDevice && _vm.virtualDeviceStates ? _c(VDataTable, {
    attrs: {
      "headers": _vm.virtualDeviceVariableHeaders,
      "footer-props": _vm.virtualDeviceVariableFooterProps,
      "items": _vm.virtualDeviceStates,
      "single-select": false,
      "show-select": _vm.mode !== 'readonly',
      "item-key": _vm.templateContext ? 'key' : 'id',
      "data-cy": "aggregated_state_virtual_device_state_table"
    },
    scopedSlots: _vm._u([!_vm.templateContext ? {
      key: "item.value.value",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "140px"
          }
        }, [_vm._v(_vm._s(JSON.stringify(item.value.value)))])];
      }
    } : null, {
      key: "item.milliseconds_ago",
      fn: function ({
        item
      }) {
        return [_vm._v("\n              " + _vm._s(item.time_ago) + "\n            ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selectedVirtualDeviceState,
      callback: function ($$v) {
        _vm.selectedVirtualDeviceState = $$v;
      },
      expression: "selectedVirtualDeviceState"
    }
  }) : _vm._e()], 1)], 1), !_vm.isNullOrEmpty(_vm.aggregateStateValue) ? _c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0"
  }, [_c(VExpansionPanels, [_c(VExpansionPanel, {
    on: {
      "change": function ($event) {
        return _vm.refreshForm();
      }
    }
  }, [_c(VExpansionPanelHeader, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.value')) + "  \n                  "), _c(VIcon, [_vm._v("fal fa-info-circle")])], 1)]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "card-description mt-0"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iothubaggregate.valuePreviewText1')) + "\n                ")]), _c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "value": JSON.stringify(_vm.aggregateStateValue, null, 1),
      "options": _vm.cmOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };